import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { EnvironmentCountries } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';
import { useSettings } from '../../useSettings';
import { saveBlobDownload } from './saveBlobDownload';

interface HookProps {
  batchId: string;
  reportId?: string;
}

export const useDownloadUtbReport = () => {
  const queryClient = useQueryClient();
  const { data: settings } = useSettings();
  const reportName = settings.country === EnvironmentCountries.NL ? 'UTB' : 'Customs Debt';

  return useMutation({
    mutationFn: async ({ batchId, reportId }: HookProps) => {
      const result = await apiClient.batchesReports.downloadUtbReport.mutation({ params: { id: batchId }, body: { reportId } });
      if (result.status === 204) {
        toast.info(`The ${reportName} report is not ready yet. It will appear in the Reports menu once generated.`);
        return;
      }
      if (result.status !== 200) throw result.body;

      saveBlobDownload(result.body as Blob, result.headers.get('content-disposition'));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
    },
    onError: (error) => {
      showErrorToast(error, `Error downloading the ${reportName} report!`);
    },
  });
};
